export default "__VITE_ASSET__8d2470eb__"